var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { stroke: '#none', d: 'M12.858 4.236L9.68 9.738a2.824 2.824 0 00.96 3.813l-1.548 2.683a1.412 1.412 0 01-1.929.517l-1.222-.706a1.412 1.412 0 01-.517-1.929L8.6 8.614c.225-.388.612-.64 1.05-.695a.706.706 0 10-.176-1.4 2.82 2.82 0 00-2.096 1.39L4.202 13.41a2.824 2.824 0 001.034 3.857l1.222.706c1.35.78 3.078.317 3.857-1.033l3.177-5.502a2.824 2.824 0 00-.96-3.813l1.548-2.683a1.412 1.412 0 011.929-.517l1.223.706c.675.39.906 1.253.516 1.928l-1.76 3.05a.667.667 0 00.244.911l.034.018a.75.75 0 00.985-.294l1.72-2.979a2.824 2.824 0 00-1.034-3.857l-1.222-.706a2.824 2.824 0 00-3.857 1.034zM11.825 8.85l-.072-.046c.675.39.906 1.253.516 1.928l-.92 1.593-.05-.032a1.412 1.412 0 01-.395-1.85l.92-1.593zm8.236 10.017l-.089.105a.847.847 0 01-1.093.09l-.105-.09-1.398-1.398-1.397 1.398a.847.847 0 01-1.093.09l-.105-.09a.847.847 0 01-.09-1.093l.09-.105 1.398-1.398-1.398-1.397a.847.847 0 01-.09-1.093l.09-.105a.847.847 0 011.093-.09l.105.09 1.397 1.398 1.398-1.398a.847.847 0 011.093-.09l.105.09a.847.847 0 01.09 1.093l-.09.105-1.398 1.397 1.398 1.398a.847.847 0 01.09 1.093l-.09.105.09-.105z', strokeWidth: '.5', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function deleted(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};